export const reschedule = {
  'Confirm schedule': 'Confirmar agenda',
  'Select the date and time of the schedule':
    'Selecione o dia e horário da agenda',
  'Session successfully rescheduled to {{unit}}, {{date}} at {{time}}!':
    'Sessão reagendada com sucesso para {{unit}}, {{date}} às {{time}}!',
  "You're almost at your schedule, but before choose where do you want to receive your confirmation code from":
    'Falta pouco para você realizar seu agendamento, antes escolha por onde você deseja receber o código de confirmação',
};
